<ng-template #controls>
  <select id="picker-years" class="years" (change)="onDateFieldSelection( $event )">
    <option disabled [selected]="!$initialMonth()">year</option>
    @for( year of $allYears(); track $index ){
    <option [value]="year" [selected]="$initialMonth() && $selectedYear() === year">{{ year }}</option>
    }
  </select>
  <div class="spacer"></div>
  <select class="months" (change)="onDateFieldSelection( $event )">
    <option disabled [selected]="!$initialMonth()">month name</option>
    @let months = [ {idx: 0, name: 'January'}, {idx: 1, name: 'February'}, {idx: 2, name: 'March'}, {idx: 3, name:
    'April'}, {idx: 4, name: 'May'}, {idx: 5, name: 'June'}, {idx: 6, name: 'July'}, {idx: 7, name: 'August'}, {idx: 8,
    name: 'September'}, {idx: 9, name: 'October'}, {idx: 10, name: 'November'}, {idx: 11, name: 'December'} ]; @for(
    month of months; track month.idx ){
    <option value="{{ month.idx }}" [selected]="$initialMonth() && $selectedMonthIdx() === month.idx">
      {{ month.name }}
    </option>
    }
  </select>
</ng-template>
@if( $label() ){
<label for="picker-years">{{ $label() }}</label>
<div class="controls">
  <ng-container *ngTemplateOutlet="controls" />
</div>
} @else {
<ng-container *ngTemplateOutlet="controls" />
}
